var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.projectDetailsRoute(_vm.project)}},[_c('div',{staticClass:"avatar relative",class:[
      {'bg-cover' : _vm.thumbnail},
      {'avatar--small' : _vm.small},
      {'pa-2' : !_vm.thumbnail && _vm.small},
      {'pa-5' : !_vm.thumbnail && !_vm.small},
    ],style:(_vm.thumbnail && `background-image: url(${_vm.thumbnail.url})`)},[(!_vm.thumbnail || !_vm.thumbnail.url)?_c('v-img',{staticClass:"d-block",attrs:{"src":require("@/assets/img/img-blank.svg")}}):_vm._e(),(_vm.project.pinned)?_c('v-icon',{staticClass:"pin-icon",class:{'pin-icon--small' : _vm.small},attrs:{"x-small":_vm.small,"small":!_vm.small,"color":"primary"}},[_vm._v(" mdi-pin ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }